import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { paths } from 'src/paths';
import { useMobile } from 'src/hooks/use-mobile';
import { styled } from '@mui/material/styles';
import { Footer } from './footer';
import { SideNav } from './side-nav';
import { TopNav } from './top-nav';
import { useMobileNav } from './use-mobile-nav';
import { NoticeProvider } from 'src/components/notice-provider';

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%'
}));

export const Layout = (props) => {
  const { children } = props;
  const { pathname } = useLocation();
  const isMobile = useMobile();
  const mobileNav = useMobileNav();

  return (
    <>
      <TopNav onMobileNavOpen={mobileNav.handleOpen} />
      {isMobile && (
        <SideNav
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
        />
      )}
      <LayoutRoot>
        <NoticeProvider target="HOME">
          {children}
        </NoticeProvider>
        <Footer showBusinessInfo={pathname === paths.index} />
      </LayoutRoot>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node
};
